// TODO: Move this file into the source directory
document.addEventListener('DOMContentLoaded', () => {
    const closeIcon = document.getElementById('labrets-drawer-close-icon');
    const labretTrigger = document.getElementById('labret-upsell-trigger');
    const labretsDrawer = document.getElementById('labret-drawer');
    const overlay = document.getElementById('upsell_overlay');
    const successMessageContainer = document.getElementById('upsell-success--container');
    const successMessageTranslation = document.getElementById('success-message-translation').innerHTML;
    console.log("translation", successMessageTranslation);

    labretTrigger.addEventListener('click', () => {
        labretTrigger.setAttribute("aria-expanded", "true");
        labretsDrawer.classList.toggle('open');
        overlay.classList.toggle('active');
        document.body.classList.toggle('has-modal-open');
    });

    function closeDrawer() {
        labretsDrawer.classList.remove('open');
        overlay.classList.remove('active');
        document.body.classList.remove('has-modal-open');
        document.body.style.overflow = '';
    }

    closeIcon.addEventListener('click', () => {
        labretTrigger.setAttribute("aria-expanded", "false");
        closeDrawer();
    })

    // Closing on overlay click
    if (overlay) {
        overlay.addEventListener('click', () => {
            closeDrawer();
        });
    }

    //Closing on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && labretsDrawer.classList.contains('open')) {
            labretsDrawer.classList.remove('open');
            if (overlay) overlay.classList.remove('active');
            document.body.style.overflow = '';
        }
    });

    document.addEventListener("click", function(e) {
        const atcBtns = e.target.closest(".js-upsell-atc");
        if (!atcBtns || atcBtns.classList.contains("is-loading")) return;

        const variantId = atcBtns.dataset.variantId;
        const productTitle = atcBtns.dataset.variantName;


        const plusIcon = atcBtns.querySelector('.upsell-atc__icon--plus');
        const spinnerIcon = atcBtns.querySelector('.upsell-atc__icon--spinner');

        atcBtns.classList.add('is-loading');
        plusIcon.hidden = true;
        spinnerIcon.hidden = false;

     
        const formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", 1);

        window.Cart.addToCart(formData)
        .then(() => {
            successMessageContainer.innerHTML = productTitle + ' ' + successMessageTranslation;
            labretsDrawer.classList.remove('open');
            overlay.classList.remove('active');
            labretTrigger.setAttribute("aria-expanded", "false");
        })
        .catch(err => {
            console.log("Cart error:", err);
        })
        .finally(() => {
            atcBtns.classList.remove("is-loading");
            plusIcon.hidden = false;
            spinnerIcon.hidden = true;
        });
    });

});